export default __webpack_public_path__ + "static/media/trash.8faa751b.svg";